import { Injectable } from "@angular/core";
import { RefreshModel } from "src/app/Context/contextapplication/models/refresh.model";
import { Observable } from "rxjs";
import { Token } from "src/app/Context/contextapplication/models/token";
import { User } from "src/app/Context/contextapplication/models/users";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  urlServiceREST: string = "/api/connect/token";

  /**
   *
   */
  constructor(public httpClient: HttpClient) { }

  /**
   * Obtém o token de acesso usando as credenciais do usuário.
   * 
   * @param username - O nome de usuário.
   * @param password - A senha do usuário.
   * @param baseUrl - A url base do serviço de autenticação.
   * @returns O token de acesso se obtido com sucesso.
   * @throws Erro se não for possível obter o token.
   */
  public async GetAccessToken(username: string, password: string, baseUrl: string): Promise<any> {

    try {
      const user: User = new User();
      user.username = username;
      user.password = password;

     await this.getToken(user, baseUrl).forEach((token) => {
        sessionStorage.setItem('tokenBearer', JSON.stringify(token));
      });

    } catch (error) {
      console.error('Erro ao decodificar o token:', error);
      return null;
    }
  }

  /**
   * Faz o refresh da token bearer
   */
  public refreshToken(refreshToken: string, baseUrl: string): Observable<Token> {

    const refreshTokenInfo: RefreshModel = <RefreshModel>{
      grant_type: 'refresh_token',
      refresh_token: refreshToken,
    };
    const url = `${baseUrl}${this.urlServiceREST}`

    return this.httpClient.post<Token>(url, refreshTokenInfo);

  }

  public getToken(objLogin: User, baseUrl: string): Observable<Token> {
    const url = `${baseUrl}${this.urlServiceREST}`
    return this.httpClient.post<Token>(url, objLogin);
  }


}
